import {
  END_POINT_CVS,
  END_POINT_CVS_DETAIL,
  END_POINT_UPLOAD_FILE
} from "../api/EndPoint";
import { JWT } from "../utils/CommonConstant";
import { CV_LIST, CV_DETAIL, OPEN_MODEL, UNAUTHORIZE } from "./ActionType";
import { GET_SUCCESS, INSERT_SUCCESS, RESPONSE_CODE_UNAUTHORIZED } from "../api/ResponseType";
import axios from "axios";
import sha256 from "crypto-js/sha256";

export const getCvList = (page_index) => dispatch => {
  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      Authorization: sessionStorage.getItem(JWT)
    },
    withCredentials: false,
    mode: "no-cors",
    url: END_POINT_CVS,
    params: { page: page_index, sort: "-_created", embedded: 1}
  }).then(response => {
    
      if (response.status === GET_SUCCESS) {
        dispatch({
          type: CV_LIST,
          payload: response.data._items
        });
      } else {
        window.alert("SERVER ERROR FOUND");
      }
    })
    .catch(error => {
     
      window.alert("NETWORK ERROR"+ error);
    });
};

export const getCvListWithCookies = (page_index, jwt) => dispatch => {
  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      Authorization: jwt//sessionStorage.getItem(JWT)
    },
    withCredentials: false,
    mode: "no-cors",
    url: END_POINT_CVS,
    params: { page: page_index, sort: "-_created", embedded: {job_id: 1}}
  })
    .then(response => {
    

      if (response.status === GET_SUCCESS) {
        dispatch({
          type: CV_LIST,
          payload: response.data._items
        });
      } else {
        window.alert("SERVER ERROR FOUND");
      }
    })
    .catch(error => {
     
      window.alert("NETWORK ERROR"+ error);
    });
};

export const getCvDetail = cv_id => dispatch => {
  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      Authorization: sessionStorage.getItem(JWT)
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_CVS_DETAIL}${cv_id}`
  })
    .then(response => {
     
      if (response.status === GET_SUCCESS) {
        
        dispatch({
          type: CV_DETAIL,
          payload: response.data
        });
      } else {
        window.alert("SERVER ERROR!");
      }
    })
    .catch(error => {
      window.alert("NETWORK ERROR!", error);
    });
};

export const getCvDetailWithCookies = (cv_id, jwt) => dispatch => {
  axios({
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": true,
      Authorization: jwt
    },
    withCredentials: false,
    mode: "no-cors",
    url: `${END_POINT_CVS_DETAIL}${cv_id}`
  })
    .then(response => {
     
      if (response.status === GET_SUCCESS) {
        
        dispatch({
          type: CV_DETAIL,
          payload: response.data
        });
      } else {
        window.alert("SERVER ERROR!");
      }
    })
    .catch(error => {

      if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
        window.alert("Unauthorized! Please login again.", error);
        dispatch({
            type: UNAUTHORIZE,
            payload: true
        })
    }else{
        window.alert(error)
    }

    });
};

export const openModal =(value) => dispatch => {
  dispatch({
    type: OPEN_MODEL,
    payload: value
  })
}

export const submitCv = (event, job_id) => dispatch => {
 
  event.job_id = job_id;
  const file_data = new FormData();
  Array.from(event.cv).forEach(file => {
    file_data.append("file", file);
  })
  
  axios({
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization:
        "Bearer " +
        sha256(
          Math.random()
            .toString(36)
            .substring(7)
        )
    },
    mode: "no-cors",
    withCredentials: false,
    url: END_POINT_UPLOAD_FILE,
    data: file_data
  })
    .then(res => {
      if (res.status === GET_SUCCESS) {
       
        //event.cv_url = res.data.message.url;
        event.cvs = res.data.message;
        let data = event;
        delete data["acceptTnC"];
        delete data["cv"];
        delete data["cover_letter"]

        axios({
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              sha256(
                Math.random()
                  .toString(36)
                  .substring(7)
              )
          },
          mode: "no-cors",
          url: END_POINT_CVS,
          data: data
        }).then(res => {
          if (res.status === INSERT_SUCCESS) {
        
            window.alert("Your CV has been uploaded successfully");

            dispatch({
              type: OPEN_MODEL,
              payload: false
            })

          } else {
            window.alert("Apply Failed!");
          }
        });
      } else {
        window.alert("RESPONSE ERROR!");
      }
    })
    .catch(function(error) {
      if (
        error.response.status === 400 &&
        error.response.data._error.message === "Invalid file type"
      ) {
        window.alert("Invalid File Type");
      }
  });
};
